import {api} from 'services/api';
import {CompactDirectory} from 'types/compact-directory';
import {Directory} from 'types/directory';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const dettachCompany = api.injectEndpoints({
  endpoints: builder => ({
    dettachCompany: builder.mutation<Response, DirectoryComponentsPriceRequest>(
      {
        query: params => ({
          method: 'POST',
          url: `/directories/${params.id}/dettach-company`,
          body: {
            company_id: params.company?.id,
          },
        }),
        // @ts-expect-error
        invalidatesTags: result => {
          if (result) {
            return [{type: 'directories', id: result?.data.affected_row}];
          }
          return [];
        },
      }
    ),
  }),
});

export type DirectoryComponentsPriceRequest = {
  id?: ObjectId;
  company?: CompactDirectory;
};

type Response = ResponseData<{affected_row: ObjectId; message: string}>;

export const {useDettachCompanyMutation} = dettachCompany;
